// extracted by mini-css-extract-plugin
export default {"display":"display_display__CqFHo"};